import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link } from "react-router-dom"

import CreateContractLoan from './components/Loan/CreateLoanScreen';
import AsstesForLoan from './components/Loan/AssetsForLoan';


function AddContract() {

return (
<>
  <div className="container-fluid py-4">
    <div className="form-group row">
      <div className="col-md-12">
        <div className="header pb-0 mb-3">
          <h5 className='tc'>Add Contract</h5>
          <h6><Link to="" style={{ color: "grey" }} >Contracts</Link> / <span className='tc' >New Contract</span> </h6>
        </div>
        <Tabs>
          <TabList>
            <Tab>
              <p>Contract Detail</p>
            </Tab>
            <Tab>
              <p>Assets Details</p>
            </Tab>
          </TabList>
          <TabPanel>
            <div className="panel-content">
              <div className="col-md-12">
                <CreateContractLoan />
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="panel-content">
              <AsstesForLoan />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </div>
    <div className="col-md-10">
    </div>
  </div>
</>
)
}

export default AddContract
